import axios from 'axios';
import { authHeader } from '../_helpers/auth-header';

const _appDomain = process.env.VUE_APP_DOMAIN ? process.env.VUE_APP_DOMAIN : '';
const _apiUrl = _appDomain + process.env.VUE_APP_API_URL;
const BASE_URL = _apiUrl + '/companies';

export const companyApi = {
  // 회사 목록 조회
  getCompanies(params, { signal } = {}) {
    return axios.get(BASE_URL, {
      params,
      headers: { Authorization: authHeader() },
      signal
    });
  },

  // 회사 생성
  createCompany(companyData) {
    return axios.post(BASE_URL, {
      id: companyData.id,
      companyName: companyData.companyName
    }, {
      headers: { Authorization: authHeader() }
    });
  },

  // 회사 수정
  updateCompany(companyId, companyData) {
    return axios.put(`${BASE_URL}/${companyId}`, {
      id: companyData.id,
      companyName: companyData.companyName
    }, {
      headers: { Authorization: authHeader() }
    });
  },

  // 회사 삭제
  deleteCompany(companyId) {
    return axios.delete(`${BASE_URL}/${companyId}`, {
      headers: { Authorization: authHeader() }
    });
  }
};

